import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
interface Objection {
  question: string;
  answer: string;
}
const objections: Objection[] = [{
  question: '"Ya intenté todo."',
  answer: 'No has intentado un sistema que funcione en tus días malos. Este sí está diseñado para eso.'
}, {
  question: '"No tengo fuerza de voluntad."',
  answer: 'Perfecto. No la necesitas. Necesitas fricción.'
}, {
  question: '"Mi pareja/familia me presiona a gastar."',
  answer: 'Por eso existe Loud Budget: límites simples sin explicar tu vida.'
}];
export function ObjectionsAndCTA() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleObjection = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full" data-id="element-102">
      {/* Objections */}
      <div className="py-16 md:py-24 px-6" style={{
      backgroundColor: 'var(--light-navy)'
    }} data-id="element-103">
        <div className="max-w-2xl mx-auto" data-id="element-104">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="font-serif text-2xl md:text-3xl mb-10" style={{
          color: 'var(--navy)'
        }} data-id="element-105">
            Objeciones comunes
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-base mb-8" style={{
          color: 'var(--charcoal)',
          opacity: 0.7,
          lineHeight: '1.7'
        }} data-id="element-106">
            (y respuestas honestas)
          </motion.p>

          <div className="space-y-3" data-id="element-107">
            {objections.map((obj, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="rounded-xl overflow-hidden" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.08)'
          }} data-id="element-108">
                <button onClick={() => toggleObjection(index)} className="w-full flex items-center justify-between p-5 text-left cursor-pointer" aria-expanded={openIndex === index} aria-controls={`objection-answer-${index}`} data-id="element-109">
                  <span className="font-serif text-base md:text-lg font-medium pr-4" style={{
                color: 'var(--navy)'
              }} data-id="element-110">
                    {obj.question}
                  </span>
                  <motion.span animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.25
              }} className="flex-shrink-0" data-id="element-111">
                    <ChevronDownIcon className="w-5 h-5" style={{
                  color: 'var(--gold)'
                }} data-id="element-112" />
                  </motion.span>
                </button>

                <AnimatePresence data-id="element-113">
                  {openIndex === index && <motion.div id={`objection-answer-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-114">
                      <div className="px-5 pb-5 pt-0" data-id="element-115">
                        <div className="w-12 h-px mb-4" style={{
                    backgroundColor: 'var(--gold)',
                    opacity: 0.3
                  }} data-id="element-116" />
                        <p className="text-base" style={{
                    color: 'var(--charcoal)',
                    lineHeight: '1.7'
                  }} data-id="element-117">
                          {obj.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div id="cta-final" className="py-20 md:py-32 px-6" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-118">
        <div className="max-w-2xl mx-auto text-center" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7
        }} data-id="element-120">
            <p className="font-serif text-xl md:text-2xl leading-relaxed mb-4" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.6'
          }} data-id="element-121">
              Si estás cansada/o de empezar cada mes con esperanza y terminarlo
              con vergüenza…
            </p>
            <p className="font-serif text-2xl md:text-3xl font-semibold mb-12" style={{
            color: 'var(--navy)'
          }} data-id="element-122">
              haz el reset.
            </p>

            <p className="text-base mb-8" style={{
            color: 'var(--charcoal)',
            opacity: 0.75,
            lineHeight: '1.7'
          }} data-id="element-123">
              Compra{' '}
              <strong style={{
              color: 'var(--navy)'
            }} data-id="element-124">
                "Reset de Deudas en 14 Días (USA)"
              </strong>{' '}
              hoy y empieza el Día 1 en menos de 30 minutos.
            </p>

            {/* Price */}
            <div className="mb-8 flex flex-col items-center gap-3" data-id="element-125">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" style={{
              backgroundColor: 'var(--green)',
              color: 'white'
            }} data-id="element-126">
                68% OFF
              </span>
              <div className="flex items-baseline gap-3" data-id="element-127">
                <span className="text-xl md:text-2xl line-through" style={{
                color: 'var(--charcoal)',
                opacity: 0.4
              }} data-id="element-128">
                  $19.99
                </span>
                <span className="font-serif text-4xl md:text-5xl font-bold" style={{
                color: 'var(--green)'
              }} data-id="element-129">
                  $6.39
                </span>
              </div>
              <p className="text-sm" style={{
              color: 'var(--charcoal)',
              opacity: 0.5
            }} data-id="element-130">
                Precio de lanzamiento — acceso inmediato
              </p>
            </div>

            {/* CTA Button */}
            <motion.a href="https://mdbhorizonte.com/cart/52013919502628:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="cta-glow inline-block px-10 py-5 rounded-xl text-lg font-bold tracking-wide transition-colors duration-300" style={{
            backgroundColor: 'var(--navy)',
            color: 'var(--gold)',
            border: '2px solid var(--gold)'
          }} aria-label="Comprar Reset de Deudas en 14 Días" data-id="element-131">
              QUIERO MI RESET (14 DÍAS)
            </motion.a>

            {/* Microcopy */}
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-132">
              <span className="flex items-center gap-1.5 text-sm" style={{
              color: 'var(--charcoal)',
              opacity: 0.6
            }} data-id="element-133">
                <CheckIcon className="w-4 h-4" style={{
                color: 'var(--green)'
              }} data-id="element-134" />
                Acceso inmediato (PDF)
              </span>
              <span className="flex items-center gap-1.5 text-sm" style={{
              color: 'var(--charcoal)',
              opacity: 0.6
            }} data-id="element-135">
                <CheckIcon className="w-4 h-4" style={{
                color: 'var(--green)'
              }} data-id="element-136" />
                Hecho para 35+ en USA (español)
              </span>
              <span className="flex items-center gap-1.5 text-sm" style={{
              color: 'var(--charcoal)',
              opacity: 0.6
            }} data-id="element-137">
                <CheckIcon className="w-4 h-4" style={{
                color: 'var(--green)'
              }} data-id="element-138" />
                Sin apps complicadas
              </span>
              <span className="flex items-center gap-1.5 text-sm" style={{
              color: 'var(--charcoal)',
              opacity: 0.6
            }} data-id="element-139">
                <CheckIcon className="w-4 h-4" style={{
                color: 'var(--green)'
              }} data-id="element-140" />
                Paso a paso, sin humillarte
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}